import { Game } from './classes/Game';

const game = new Game('tetris');
